import React from 'react'
import { Icon } from 'antd'

const PreLoader = () => (
  <div
    style={{
      width: '100%',
      display: 'flex',
      minHeight: 100,
      height: '100%',
      alignItems: 'center',
      justifyContent: 'center'
    }}>
    <Icon type="loading" style={{ fontSize: '26px'}}/>
  </div>
)

export default PreLoader;



// WEBPACK FOOTER //
// ./src/elements/pre-loader/index.js